import React from 'react';
import { Headline } from '@oneaudi/unified-web-components';
import { useIsMobileScreen } from '../../../hooks/useWindowSize';
import { MapMarkerContainer, MapMarkerNumOfDealers, MapMarkerContent } from './MapMarker.styled';

export type Props = {
  numDealers: number;
  onClick: () => void;
};

export const ClusterMarker = ({ numDealers, onClick }: Props) => {
  const isMobileScreen = useIsMobileScreen();

  return (
    <MapMarkerContainer
      isMobileScreen={isMobileScreen}
      data-test-id="cluster-marker"
      onClick={onClick}
    >
      <MapMarkerContent>
        <MapMarkerNumOfDealers>
          <Headline tag="span" variant={{ order: '2', type: 'headline', weight: 'normal' }}>
            {numDealers}
          </Headline>
        </MapMarkerNumOfDealers>
      </MapMarkerContent>
    </MapMarkerContainer>
  );
};
